import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse'
import { Link } from 'react-router-dom';

//TODO: take navigation link also via props
export class ListItemRender extends Component {
  constructor(props) {
    super(props);
    this.prevSlug = null
    this.state = {
      anchorEl: null,
      openSubId: this.props.openSubId,
      openId: this.props.openId,
    }
  }

  handleClick = (e) => {
    const openId = this.state.openId
    if (openId === e) {
      this.setState({
        openId: null,
        openSubId: null,
      });
    } else {
      this.setState({
        openId: e,
        openSubId: null,
      });
    }
  };

  handleSubClick = (e) => {
    const openSubId = this.state.openSubId
    if (openSubId === e) {
      this.setState({
        openSubId: null
      });
    } else {
      this.setState({
        openSubId: e,
      });
    }
  };

  renderSubCategories = (sitem, index) => {
    if (!sitem.slug) {
      return ''
    }

    let allDisabled = true
    if (sitem.subCategories && sitem.subCategories.length > 0) {
      for (const i of sitem.subCategories) {
        if (i.state !== 'DISABLED') {
          allDisabled = false
          break
        }
      }
    }

    if (sitem.state === 'DISABLED') {
      return ''
    }


    if (!sitem.subCategories || sitem.subCategories.length === 0 || allDisabled) {
      return (
        <ListItem
          className={css(Styles.listItem)}
          key={index}>
          <ListItemText
            className={css([Styles.listText, Styles.subListItemText])}
            primary={sitem.title} />
        </ListItem>
      )
    }

    return (
      <div key={index}>
        <ListItem
          button
          onClick={this.handleSubClick.bind(this, sitem.id)}
          className={css(Styles.listItem)}
        >
          <ListItemText
            className={css([Styles.listText, Styles.subListItemText])}
            primary={sitem.title} />
          {this.state.openSubId === sitem.id ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          key={sitem.id}
          component='li'
          in={this.state.openSubId === sitem.id}
          timeout='auto'
          unmountOnExit>
          <List disablePadding>
            {sitem.subCategories.map((nsItem, index) => {
              if (!nsItem.slug) {
                return ''
              }
              if (nsItem.state === 'DISABLED') {
                return ''
              }
              return (
                <Link
                  to={{
                    pathname: '/specialties/' + nsItem.slug,
                    state: {
                      nsItem: nsItem,
                      openId: this.state.openId,
                      openSubId: this.state.openSubId
                    }
                  }}
                  key={index}
                  className={css(CommonStyles.link)}>
                  <ListItem
                    className={css(Styles.listItem)}
                    key={index}>
                    <ListItemText
                      className={(this.props.slug && (nsItem.slug === this.props.slug)) ?
                        css([Styles.listText, Styles.nestedSubListItemText, Styles.activeLabel]) :
                        css([Styles.listText, Styles.nestedSubListItemText])}
                      primary={nsItem.title} />
                  </ListItem>
                </Link>
              )
            })}
          </List>
        </Collapse>
      </div>
    )
  }

  renderList = (item, index) => {
    if (!item.slug) {
      return ''
    }

    if (item.state === 'DISABLED') {
      return ''
    }

    let allDisabled = true
    if (item.subCategories && item.subCategories.length > 0) {
      for (const i of item.subCategories) {
        if (i.state !== 'DISABLED') {
          allDisabled = false
          break
        }
      }
    }

    if (!item.subCategories || item.subCategories.length === 0 || allDisabled) {
      return (
        <ListItem
          className={css(Styles.listItem)}
          key={index}>

          <ListItemText
            className={css(Styles.listText)}
            primary={item.title} />
        </ListItem>
      )
    }

    return (
      <div key={index}>
        <ListItem
          button
          onClick={this.handleClick.bind(this, item.id)}
          className={css(Styles.listItem)}
        >
          <ListItemText
            className={css(Styles.listText)}
            primary={item.title} />
          {this.state.openId === item.id ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          key={item.id}
          component='li'
          in={this.state.openId === item.id}
          timeout='auto'
          unmountOnExit>
          <List disablePadding>
            {item.subCategories.map((sitem, index) => {
              return this.renderSubCategories(sitem, index)
            })}
          </List>
        </Collapse>
      </div>
    )
  }

  renderDesktop() {
    if (this.props.data.length === 0) {
      return <p className={css(Styles.emptyView)}>Categories not found</p>
    }

    return (
      <div>
        <h4 className={css(Styles.listTitle)}>
          {this.props.title}
        </h4>

        <List>
          {
            this.props.data.map((item, index) => {
              return this.renderList(item, index)
            })}
        </List>
      </div>
    )
  }

  handleCatContainerClick = () => {
    const catContainerId = this.state.catContainerId
    if (catContainerId) {
      this.setState({
        catContainerId: null
      })
    } else {
      this.setState({
        catContainerId: 'catContainer'
      })
    }
  }

  renderMobile() {
    if (this.props.data.length === 0) {
      return <p className={css(Styles.emptyView)}>Categories not found</p>
    }

    return (
      <div>
        <ListItem
          button
          onClick={this.handleCatContainerClick.bind(this)}
          className={css(Styles.listItemtitle)}
        >
          <ListItemText
            className={css(Styles.listTitle)}
            primary={this.props.title} />
          {this.state.catContainerId ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          key={'catContainer'}
          //component='li'
          in={this.state.catContainerId === 'catContainer'}
          timeout='auto'
          unmountOnExit>
          <List disablePadding>
            {
              this.props.data.map((item, index) => {
                return this.renderList(item, index)
              })}
          </List>
        </Collapse>
      </div>
    )
  }

  isSlugChanged = () => {
    if (this.prevSlug !== this.props.slug) {
      this.prevSlug = this.props.slug
      this.setState({
        catContainerId: null
      })
    }
  }

  render() {
    this.isSlugChanged()
    return (
      <div>
        {window.innerWidth > 767 &&
          <div className={css(Styles.deskTopView)}>
            {this.renderDesktop()}
          </div>
        }
        {window.innerWidth < 768 &&
          <div className={css(Styles.mobileView)}>
            {this.renderMobile()}
          </div>
        }
      </div>

    )
  }
}

const Styles = StyleSheet.create({
  emptyView: {
    minHeight: 100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
    fontSize: 14,
  },
  listItem: {
    padding: '0px 10px 0px 10px',
    borderRadius: 15,
    ':hover': {
      cursor: 'pointer',
      backgroundColor: '#F4F4F4',
    }
  },
  subListItemText: {
    marginLeft: '20px',
  },
  nestedSubListItemText: {
    marginLeft: '35px',
  },
  listText: {
    fontSize: 12,
    padding: '5px 0px 5px 0px',
    margin: 0,
    color: '#0C4D5D',
    fontWeight: 'bolder',
    ':hover': {
      color: AppTheme.primaryColor
    }
  },
  listTitle: {
    backgroundColor: '#C2D5DE',
    padding: AppTheme.pagePadding * 2,
    color: CommonTheme.black,
    margin: 0
  },
  listItemtitle: {
    backgroundColor: '#C2D5DE',
    padding: AppTheme.pagePadding * 2,
    paddingTop: 5,
    paddingBottom: 5,
    margin: 0
  },
  deskTopView: {
    //display: 'flex',
    '@media (max-width: 767px)': {
      display: 'none'
    }
  },
  mobileView: {
    display: 'none',
    '@media (max-width: 767px)': {
      display: 'block'
    }
  },
  activeLabel: {
    color: AppTheme.primaryColor
  }
})


// WEBPACK FOOTER //
// ./src/components/ListItemRender.js